<template>
  <div>
    <v-text-field hide-details outlined readonly :value="geoLocationValue">
      <template v-slot:append>
        <!-- dialog pro radius-->
        <v-menu
          v-if="value.type === 'city'"
          v-model="menu"
          :close-on-content-click="false"
          :nudge-bottom="20"
          :nudge-width="260"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mr-3" text small v-bind="attrs" v-on="on">
              {{ geoLocationRadius }}
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-list>
              <v-list-item>
                <v-switch
                  v-model="value.useRadius"
                  label="Použít rádius"
                  @change="$emit('change', value)"
                ></v-switch>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item class="mt-12">
                <v-slider
                  v-model="value.radius"
                  dense
                  hide-details
                  :disabled="!value.useRadius"
                  :min="17"
                  :max="80"
                  thumb-label="always"
                  @input="$emit('change', value)"
                >
                  <template v-slot:prepend>
                    <span class="text-no-wrap"
                      >17 {{ geoLocationDistanceUnit }}</span
                    >
                  </template>
                  <template v-slot:append>
                    <span class="text-no-wrap"
                      >80 {{ geoLocationDistanceUnit }}</span
                    >
                  </template>
                </v-slider>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <v-icon color="red" @click="onDeleteClick">
          mdi-delete-outline
        </v-icon>
      </template>

      <v-icon slot="prepend-inner" color="gray">
        mdi-magnify
      </v-icon>
    </v-text-field>
  </div>
</template>

<script>
import { get } from "vuex-pathify"

// import Vue from "vue"

export default {
  name: "GeoLocationInput",
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      geoLocationInner: null,
      menu: false,
    }
  },
  computed: {
    ...get("enumerations", ["findTargetingLocationType"]),
    geoLocationDistanceUnit() {
      return this.value.distance_unit === "mile" ? "miles" : "km"
    },
    geoLocationRadius() {
      if (!this.value.radius || !this.value.useRadius) {
        return "Pouze město"
      }

      return `+ ${this.value.radius} ${this.geoLocationDistanceUnit}`
    },
    geoLocationValue() {
      const type = this.findTargetingLocationType(this.value.type)
      const name = this.value.fullName ? this.value.fullName : this.value.name

      return `${name} (${type.name})`
    },
  },
  methods: {
    onDeleteClick() {
      this.$emit("delete", this.value)
    },
  },
  // beforeMount() {
  //   this.geoLocationInner = this.geoLocation
  //   if (this.geoLocationInner.useRadius === undefined) {
  //     Vue.set(this.geoLocationInner, "useRadius", !!this.geoLocationInner.radius)
  //   }
  // },
}
</script>
